export const OC_TITLE_MAX_LENGTH = 150
export const OC_BODY_MAX_LENGTH = 2000
export const OC_BODY_SUMMARY_LENGTH = 100

export const OcFields = [
  {
    key: 'story',
    title: 'Story',
    items: [
      {
        key: 'title',
        title: 'Title',
        placeholder: 'Give your OC a title~',
        required: false,
        maxLength: OC_TITLE_MAX_LENGTH,
      },
      {
        key: 'body',
        title: 'Body',
        placeholder: 'Write more about your OC~',
        required: false,
        maxLength: OC_BODY_MAX_LENGTH,
      },
    ],
  },
  {
    key: 'basic',
    title: 'Basic Information',
    items: [
      {
        key: 'avatar',
        title: 'Avatar',
        placeholder: 'Change One',
        required: true,
      },
      {
        key: 'name',
        title: 'Name',
        placeholder: 'Give your avatar a name~',
        required: true,
      },
      {
        key: 'gender',
        title: 'Gender',
        placeholder: 'Are they a boy, girl, or non-binary?~',
        required: false,
      },
      {
        key: 'age',
        title: 'Age',
        required: false,
      },
      {
        key: 'birthday',
        title: 'Birthday',
        required: false,
      },
      {
        key: 'species',
        title: 'Species',
        placeholder: 'Are they human, elf, animal, or another species?',
        required: false,
      },
      {
        key: 'bio',
        title: 'Introduction',
        placeholder: 'Briefly introduce them to everyone',
        required: false,
      },
    ],
  },
  {
    key: 'appearance',
    title: 'Appearance',
    items: [
      {
        key: 'height',
        title: 'Height',
        required: false,
      },
      {
        key: 'weight',
        title: 'Weight',
        required: false,
      },
      {
        key: 'features',
        title: 'Special Features',
        placeholder: 'Maybe they have special eyes~',
        required: false,
      },
      {
        key: 'clothing',
        title: 'Clothing Style',
        placeholder: "Maybe they're sweet-cool or gentle and lovely...",
        required: false,
      },
    ],
  },
  {
    key: 'personality',
    title: 'Personality',
    items: [
      {
        key: 'mbti',
        title: 'MBTI',
        required: false,
      },
      {
        key: 'strengths',
        title: 'Strengths',
        required: false,
      },
      {
        key: 'weaknesses',
        title: 'Weaknesses',
        required: false,
      },
      {
        key: 'hobbies',
        title: 'Hobbies',
        required: false,
      },
    ],
  },
  {
    key: 'background',
    title: 'Background',
    items: [
      {
        key: 'experience',
        title: 'Experience',
        placeholder: 'Maybe they have a mysterious past, tell everyone~',
        required: false,
      },
      {
        key: 'goals',
        title: 'Future Goals',
        placeholder:
          'What do they aspire to in the future? To save the world?!!!',
        required: false,
      },
      {
        key: 'vip',
        title: 'Most Important Person',
        placeholder: 'Maybe they have someone they love the most',
        required: false,
      },
    ],
  },
  {
    key: 'skills',
    title: 'Skills',
    items: [
      {
        key: 'abilities',
        title: 'Combat/Special Abilities',
        placeholder:
          "Maybe they're great at styling, a sports expert, or have supernatural abilities...",
        required: false,
      },
      {
        key: 'occupation',
        title: 'Occupation/Identity',
        placeholder:
          'Are they a doctor, police officer, hacker, student, or hero...?',
        required: false,
      },
    ],
  },
  {
    key: 'worldview',
    title: 'Worldview',
    items: [
      {
        key: 'era',
        title: 'Era',
        placeholder:
          'Do they belong to the modern, ancient, future, or a 2D world?',
        required: false,
      },
      {
        key: 'alignment',
        title: 'Alignment',
        placeholder: 'Good or Evil',
        required: false,
      },
      {
        key: 'worldview',
        title: 'Worldview',
        placeholder: 'Idealist, Realist, Pessimist, or Hedonist',
        required: false,
      },
    ],
  },
]
